export default __webpack_public_path__ + "imgs/toForever02.3dfaa23.jpeg";